export enum ConferenceWaitingRoomTypes {
  GET = '@conferenceWaitingRoom/GET',
  GET_SUCCESS = '@conferenceWaitingRoom/GET_SUCCESS',
  GET_FAILED = '@conferenceWaitingRoom/GET_FAILED',
  SETUP = '@conferenceWaitingRoom/SETUP',
}
